import { Whale } from 'store/reporting/benchmark/types'

type Result = {
  quarters: string[]
  targetSeries: (number | null)[]
  avgSeries: (number | null)[]
  upper: (number | null)[]
  lower: (number | null)[]
}

export function calculateBenchmarkChartData(target: Whale, benchmarkWhales: Whale[], startYear: number | null): Result {
  const allQuarters = new Set<string>()

  benchmarkWhales.forEach(w => {
    Object.keys(w.cbq).forEach(q => allQuarters.add(q))
  })

  let quarters = Array.from(allQuarters).sort((a, b) => {
    const [yearA, qa] = a.split('Q').map(Number)
    const [yearB, qb] = b.split('Q').map(Number)
    if (yearA !== yearB) return yearA - yearB
    return qa - qb
  })

  if (startYear !== null) {
    quarters = quarters.filter(q => Number(q.slice(0, 4)) >= startYear)
  }

  //target is target or selected company in the dorpdown.
  const targetSeries = quarters.map(q => target.cbq[q] ?? null)

  //average series of competitors
  const avgSeries = quarters.map(q => {
    const values = benchmarkWhales
      .filter(w => w.dn !== target.dn)
      .map(w => w.cbq[q])
      .filter(v => v !== undefined)

    if (values.length === 0) return null

    const sum = values.reduce((a, b) => a + b, 0)
    return sum / (benchmarkWhales.length - 1) // we use benchmarkWhales.length instead of values.length to keep the average consistent even if some whales don't have data for that quarter, is like they have 0
    // return sum / values.length
  })

  const upper = avgSeries.map(v => (v === null ? null : v * 1.25))
  const lower = avgSeries.map(v => (v === null ? null : v * 0.75))

  return { quarters, targetSeries, avgSeries, upper, lower }
}
